import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { __, green, red } from '@web/birdz-angular';
import { ICellRendererParams } from 'ag-grid-community';
@Component({
  selector: 'app-cell-connection',
  imports: [MatTooltip, MatIconModule],
  templateUrl: './cell-connection.component.html',
  styleUrl: './cell-connection.component.scss',
})
export class CellConnectionComponent {
  icon = '';
  color = '';
  tooltip = '';

  constructor() {}

  agInit(params: ICellRendererParams) {
    if (params.value === 0 || params.value === 'false') {
      this.icon = 'cancel';
      this.color = red;
      this.tooltip = __('OPTION_NOT_CONNECTED');
    } else if (params.value === 1 || params.value === 'true') {
      this.icon = 'check_circle';
      this.color = green;
      this.tooltip = __('OPTION_CONNECTED');
    }
  }

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
